export default {
  session: 'نشست',
  operatingSystem: 'سیستم عامل',
  ip: 'آی پی',
  currentSession: 'نشست کنونی',
  otherSessions: 'سایر نشست ها',
  deleteAll: 'حذف همه'
}
